import React from "react";
import PropTypes from "prop-types";

const EvidenceVideo = ({ src, title, hideClass, width }) => (
  <div className="video-responsive">
    <iframe
      className={!hideClass ? "evidencevideo" : ""}
      src={src}
      frameBorder="0"
      allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      title={title}
      width={width || "700px"}
      height={"400px"}
    />
  </div>
);

EvidenceVideo.propTypes = {
  src: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default EvidenceVideo;
